module.exports = __webpack_public_path__ + "static/media/disconnected-min.00cc58c8.svg";